import courseService from '../../services/courseService';

const state = {
  courses: [],
  loading: false,
  error: null
};

const getters = {
  allCourses: state => state.courses,
  activeCourses: state => state.courses.filter(course => course.active),
  courseById: state => id => state.courses.find(course => course.id === id)
};

const actions = {
  async fetchCourses({ commit }) {
    commit('setLoading', true);
    try {
      const response = await courseService.getCourses();
      commit('setCourses', response.data.data);
      return response;
    } catch (error) {
      commit('setError', error.message);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },
  
  async createCourse({ commit, dispatch }, courseData) {
    commit('setLoading', true);
    try {
      const response = await courseService.createCourse(courseData);
      await dispatch('fetchCourses');
      return response;
    } catch (error) {
      commit('setError', error.message);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },
  
  async updateCourse({ commit, dispatch }, { id, courseData }) {
    commit('setLoading', true);
    try {
      const response = await courseService.updateCourse(id, courseData);
      await dispatch('fetchCourses');
      return response;
    } catch (error) {
      commit('setError', error.message);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },
  
  async deleteCourse({ commit, dispatch }, id) {
    commit('setLoading', true);
    try {
      const response = await courseService.deleteCourse(id);
      await dispatch('fetchCourses');
      return response;
    } catch (error) {
      commit('setError', error.message);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  }
};

const mutations = {
  setCourses(state, courses) {
    state.courses = courses;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setError(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}; 